import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Marca de HolaVeci. Se usa en Landing, Login y el drawer del Layout.
 * Título "¡Hola veci!" con fuente Carter One.
 *
 * props:
 *   size     -> font-size del título (por defecto 26)
 *   compacto -> true oculta el subtítulo "del barrio, para el barrio"
 *   color    -> override manual del color del título
 *   light    -> true = variante clara (sobre fondos oscuros / imágenes)
 */
export default function Logo({ size = 26, compacto = false, color, light = false }) {
  const tituloColor = color || (light ? '#FBF7F0' : 'primary.main');
  const subtituloColor = light ? 'rgba(251, 247, 240, 0.75)' : 'text.secondary';

  return (
    <Box sx={{ lineHeight: 1 }}>
      <Typography
        component="div"
        sx={{
          fontFamily: `'Carter One', 'Fraunces', Georgia, serif`,
          fontWeight: 400,
          fontSize: size,
          color: tituloColor,
          lineHeight: 1,
        }}
      >
        ¡Hola veci!
      </Typography>
      {!compacto && (
        <Typography
          variant="caption"
          sx={{ color: subtituloColor, fontSize: 11, mt: 0.5, display: 'block' }}
        >
          del barrio, para el barrio
        </Typography>
      )}
    </Box>
  );
}
